"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DayDateRange = void 0;
const day_date_1 = require("./day-date");
class DayDateRange {
    constructor(range) {
        if (new day_date_1.DayDate(range.from).isAfter(new day_date_1.DayDate(range.to))) {
            throw new Error("Cannot create a DayDateRange where from is after to");
        }
        this.from = new day_date_1.DayDate(range.from);
        this.to = new day_date_1.DayDate(range.to);
    }
    /** @deprecated */
    contains(day) {
        return day.isAfter(this.from) && day.isBefore(this.to);
    }
    containsInclusive(day) {
        if (this.from.equals(day) || this.to.equals(day)) {
            return true;
        }
        return day.isAfter(this.from) && day.isBefore(this.to);
    }
    isAfter(day) {
        return day.isAfter(this.to);
    }
    isBefore(day) {
        return day.isBefore(this.from);
    }
    /** @deprecated */
    includes(other) {
        if (other instanceof day_date_1.DayDate) {
            return other.isAfterOrEqual(this.from) && other.isBeforeOrEqual(this.to);
        }
        else if (other instanceof DayDateRange) {
            return this.from.isBeforeOrEqual(other.from) && this.to.isAfterOrEqual(other.to);
        }
    }
}
exports.DayDateRange = DayDateRange;
//# sourceMappingURL=day-date-range.js.map